<template>
  <button
    @click="playAudio"
    v-if="urlId"
    :style="{ height: height + 'px', width: height + 'px' }"
    class="audio-btn"
    :class="{ errorBtn: error }"
  >
    <!-- <audio>
      <source :src="audioSrc" type="audio/mp3" />
    </audio> -->
    <inline-svg
      :src="require('../../assets/svg/play2.svg').default"
      class="speaker-svg"
      :class="{ errorBtn: error }"
      aria-label="My image"
    ></inline-svg>
  </button>
</template>

<script>
import "./audioBtnNoPreLoad.scss";
import { audioService } from "../../services/audioService";
export default {
  name: "AudioBtnNoPreLoad",
  props: {
    urlId: {
      type: String | Number,
      require: true
    },
    height: {
      type: Number,
      default: 50
    },
    autoplay: {
      type: Boolean,
      deafult: false
    }
  },
  data() {
    return {
      audioSrc: "",
      isStop: null,
      error: false
    };
  },
  created() {
    // this.getAudio();
  },
  watch: {
    // urlId() {
    //   this.isStop = true;
    //   this.getAudio();
    // }
  },
  methods: {
    getAudio() {
      console.log(this.autoplay);
      if (this.urlId) {
        audioService.playAudio(this.urlId).then(async res => {
          const { sound_file } = await res.json();
          this.audioSrc = sound_file;
          if (!sound_file) this.error = true;
          if (this.autoplay) {
            // this.isStop = false;
            this.playAudio();
          }
          const audio = new Audio(this.audioSrc);
          audio.play();
        });
      } else {
        this.audioSrc = null;
      }
    },
    playAudio(ev) {
      if (this.audioSrc) {
        const audio = new Audio(this.audioSrc);
        audio.play();
        return;
      }
      this.getAudio();
      console.log("PLAY");
      // if (this.isStop) return;
      console.log("PLAY AFTER");
      if (ev) {
        ev.stopPropagation();
      }
      // const audio = new Audio(this.audioSrc);
      // audio.play();
    }
  },
  destroyed() {
    this.isStop = true;
  },
  components: {}
};
</script>

<style scoped>
.errorBtn {
  filter: grayscale(100%);
}
</style>



// WEBPACK FOOTER //
// audioBtnNoPreLoad.vue?d808b0ec